import { useId, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";

export default function Accordion({ items, testPrefix = "faq" }) {
    const [open, setOpen] = useState(null);
    const uid = useId();
    const reduce = useReducedMotion();
    return (
        <div className="border-t border-line">
            {items.map((item, i) => {
                const isOpen = open === i;
                const panelId = `${uid}-panel-${i}`;
                const btnId = `${uid}-btn-${i}`;
                return (
                    <div key={i} className="border-b border-line" data-testid={`${testPrefix}-item-${i}`}>
                        <button
                            id={btnId}
                            aria-expanded={isOpen}
                            aria-controls={panelId}
                            onClick={() => setOpen(isOpen ? null : i)}
                            data-testid={`${testPrefix}-button-${i}`}
                            className="flex w-full items-center justify-between gap-6 py-6 text-left transition-colors hover:text-blue sm:py-7"
                        >
                            <span className="font-display text-base font-semibold text-ink sm:text-lg">
                                {item.q}
                            </span>
                            <span
                                aria-hidden="true"
                                className={`relative flex h-8 w-8 shrink-0 items-center justify-center border transition-all duration-300 ${
                                    isOpen ? "border-blue bg-blue" : "border-line-2"
                                }`}
                            >
                                <span className={`absolute h-px w-3.5 ${isOpen ? "bg-white" : "bg-ink"}`} />
                                <span
                                    className={`absolute h-3.5 w-px transition-transform duration-300 ${
                                        isOpen ? "bg-white rotate-90" : "bg-ink"
                                    }`}
                                />
                            </span>
                        </button>
                        <AnimatePresence initial={false}>
                            {isOpen && (
                                <motion.div
                                    id={panelId}
                                    role="region"
                                    aria-labelledby={btnId}
                                    initial={reduce ? { height: "auto" } : { height: 0, opacity: 0 }}
                                    animate={{ height: "auto", opacity: 1 }}
                                    exit={reduce ? { height: 0 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                                    className="overflow-hidden"
                                >
                                    <p className="body-lg max-w-3xl pb-7 pr-10">{item.a}</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                );
            })}
        </div>
    );
}
